import type { ButtonProps} from '@chakra-ui/react'
import { Button, forwardRef } from '@chakra-ui/react'
import {} from 'react'

export const HeaderButton = forwardRef<ButtonProps, 'button'>((props, ref) => (
  <Button
    ref={ref}
    size="md"
    h={9}
    colorScheme="gray"
    variant="ghost"
    _hover={{ bg: 'primary.600' }}
    gap={2}
    {...props}
  />
))
